<script>
import { useI18n } from "vue-i18n";
import { mapGetters, mapActions } from "vuex";
import CompanyBox from "../components/CompanyBox.vue";

export default {
  components: { CompanyBox },
  computed: {
    ...mapGetters("company", ["getCompanies"]),
    sortedCompanies() {
      if (!this.getCompanies) return [];
      return [...this.getCompanies].sort((a, b) => {
        // Partner kommer först
        if (a.partner && !b.partner) return -1;
        if (!a.partner && b.partner) return 1;

        // Om båda är partner eller båda ej partner, sortera på namn
        return a.name.localeCompare(b.name);
      });
    },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  async mounted() {
    await this.fetchCompanies();

    const date = "2026-11-10";

    if (this.$store.state.token) {
      await Promise.all(
        this.getCompanies.map((company) =>
          this.fetchTimes({ companyId: company._id, date }).catch((err) => {
            console.error(`Failed to fetch times for ${company.name}:`, err);
          }),
        ),
      );
    }
  },
  methods: {
    ...mapActions("company", ["fetchCompanies"]),
    ...mapActions("meeting", ["fetchTimes"]),
  },
};
</script>

<template>
  <v-container class="mt-16">
    <p class="text-center text-h3 font-weight-bold mt-5">
      {{ t("company.all") }}
    </p>
    <v-row justify="center" class="my-5">
      <v-col cols="11" md="9" class="text-center">
        <v-card flat>
          <v-card-text class="text-body-1">
            <p
              v-html="
                t('company.intro.readAbout', {
                  readMore: `<strong>${t(
                    'company.readMore',
                  ).toUpperCase()}</strong>`,
                  interested: `<strong>${t(
                    'company.interested',
                  ).toUpperCase()}</strong>`,
                  requestMeeting: `<strong>${t(
                    'company.applyContactMeeting',
                  ).toUpperCase()}</strong>`,
                })
              "
            ></p>

            <p class="mt-6">
              {{ t("company.intro.contactMeeting") }}
            </p>

            <p class="mt-6 font-weight-bold text-error">
              {{ t("company.intro.note") }}
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mb-4">
      <v-col
        v-for="(company, index) in sortedCompanies || []"
        :key="index"
        cols="12"
        sm="6"
        md="6"
        lg="4"
        class="d-flex justify-center"
      >
        <CompanyBox :company="company" />
      </v-col>
    </v-row>
  </v-container>
</template>
